import React from 'react';
import { T, RADIUS } from './messagesModel';

/** The handset, the camera, and the handset with the missed cross — 2px square-capped strokes. */
export const CALL_ICONS = {
  phone: 'M5 3h4l2 5-3 2a12 12 0 0 0 6 6l2-3 5 2v4a2 2 0 0 1-2 2A18 18 0 0 1 3 5a2 2 0 0 1 2-2z',
  video: 'M3 6h12v12H3zM15 10l6-3v10l-6-3z',
  missed: 'M5 3h4l2 5-3 2a12 12 0 0 0 6 6l2-3 5 2v4a2 2 0 0 1-2 2A18 18 0 0 1 3 5a2 2 0 0 1 2-2zM15 3l6 6M21 3l-6 6',
};

export function CallIcon({ name, size = 16, strokeWidth = 2, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="square" {...rest}>
      <path d={CALL_ICONS[name] || CALL_ICONS.phone} />
    </svg>
  );
}

/**
 * The body of a call record (handoff Part B §8): a 36px icon circle, the label, the sub line,
 * and CALL BACK where there is someone to call back. `view` comes from callRecordView.
 */
export default function CallRecordCard({ view, video = false, mine = false, onCallBack = null }) {
  const icon = view.missed ? 'missed' : video ? 'video' : 'phone';
  const colour = view.missed ? T.danger : T.ink;
  return (
    <div data-testid="call-record" data-missed={view.missed ? 'true' : undefined} className="flex items-center" style={{ gap: 10 }}>
      <span style={{ width: 36, height: 36, borderRadius: '50%', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: mine ? 'rgba(255,255,255,.55)' : T.off, color: colour }}>
        <CallIcon name={icon} />
      </span>
      <span className="flex-1 flex flex-col font-mono" style={{ gap: 3 }}>
        <span className="font-bold" style={{ fontSize: 11, letterSpacing: '.1em', color: colour }}>{view.label}</span>
        <span style={{ fontSize: 9, letterSpacing: '.1em', color: T.grey500 }}>{view.sub}</span>
      </span>
      {view.callBack && onCallBack && (
        <button
          type="button"
          onClick={onCallBack}
          className="font-mono font-bold hover:bg-black hover:text-white"
          style={{ height: 28, padding: '0 12px', borderRadius: RADIUS.pill, border: `2px solid ${T.ink}`, background: T.white, fontSize: 9, letterSpacing: '.1em', cursor: 'pointer', transition: 'background-color 200ms, color 200ms' }}
        >
          CALL BACK
        </button>
      )}
    </div>
  );
}
